/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ActivateAgentConnectorRequest = {
  /**
   * The agent ID.
   */
  id: string;
  /**
   * The connector ID.
   */
  connectorId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ActivateAgentConnectorRequest$inboundSchema: z.ZodType<
  ActivateAgentConnectorRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  connectorId: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ActivateAgentConnectorRequest$Outbound = {
  id: string;
  connectorId: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ActivateAgentConnectorRequest$outboundSchema: z.ZodType<
  ActivateAgentConnectorRequest$Outbound,
  z.ZodTypeDef,
  ActivateAgentConnectorRequest
> = z.object({
  id: z.string(),
  connectorId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function activateAgentConnectorRequestToJSON(
  activateAgentConnectorRequest: ActivateAgentConnectorRequest,
): string {
  return JSON.stringify(
    ActivateAgentConnectorRequest$outboundSchema.parse(
      activateAgentConnectorRequest,
    ),
  );
}
export function activateAgentConnectorRequestFromJSON(
  jsonString: string,
): SafeParseResult<ActivateAgentConnectorRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ActivateAgentConnectorRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ActivateAgentConnectorRequest' from JSON`,
  );
}
